import React from 'react';

import {Box, Typography} from '@mui/material';

import {useAppSelector} from '../../hooks';
import {getBuildInfo} from '../../utils/version';

const BuildInfo = () => {
  const {showBuildInfo} = useAppSelector((s) => s.app);

  return showBuildInfo ? (
    <Box
      sx={{
        paddingY: '2px',
        height: '36px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#ffc107'
      }}
    >
      <Typography>{getBuildInfo()}</Typography>
    </Box>
  ) : null;
};

export default BuildInfo;
